module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_vanersborg-56c814068193fe48ab28e7bdb4429125.png";